import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { config } from '../config/env'
import { readRememberedShop } from '../utils/shopIdentity'

// This shop's name and branch from the last visit, so the first paint (the sign-in
// page) already names the right shop. useBusinessInfo replaces it with fresh data.
const rememberedShop = readRememberedShop()

const useAppStore = create(
  devtools(
    (set) => ({
      // Theme state
      theme: 'light',
      setTheme: (theme) => set({ theme }, false, 'setTheme'),
      
      // Loading state
      isLoading: false,
      setLoading: (loading) => set({ isLoading: loading }, false, 'setLoading'),
      
      // User state
      user: null,
      setUser: (user) => set({ user }, false, 'setUser'),
      
      // Business information state
      businessInfo: {
        BusinessName: rememberedShop?.BusinessName || config.appTitle,
        BusinessAddress: null,
        BusinessPhone: null,
        BusinessEmail: null,
        BranchLocation: rememberedShop?.BranchLocation || null
      },
      setBusinessInfo: (businessInfo) => set({ businessInfo }, false, 'setBusinessInfo'),

      // Optional features this branch has switched on (GET /features). null until loaded,
      // so route guards can wait instead of reading "not loaded yet" as "off".
      features: null,
      setFeatures: (features) => set({ features }, false, 'setFeatures'),
      
      // Notifications
      notifications: [],
      addNotification: (notification) => 
        set((state) => ({
          notifications: [...state.notifications, { ...notification, id: Date.now() }]
        }), false, 'addNotification'),
      removeNotification: (id) =>
        set((state) => ({
          notifications: state.notifications.filter(n => n.id !== id)
        }), false, 'removeNotification'),

      // Unsaved-changes guard. A page with a dirty form registers a function that returns
      // true when navigation may proceed (usually after a window.confirm). The navigation
      // modal consults it before changing route. The app uses a plain BrowserRouter, so
      // this is the only in-app interception available; beforeunload covers refresh/close.
      leaveGuard: null,
      setLeaveGuard: (fn) => set({ leaveGuard: fn }, false, 'setLeaveGuard'),
    }),
    {
      name: 'app-store',
    }
  )
)

export { useAppStore }
